/* eslint-disable camelcase */
import { Badge, Box, Grid } from '@mui/material';
import { m } from 'framer-motion';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../components/Image';
import { S3_ASSETS_URL } from '../../config';
import useResponsive from '../../hooks/useResponsive';
import { useSelector } from '../../redux/store';

// Test Socials
// const siteSettings = {
//   config_telegram: 'https://google.com',
//   config_wechat: 'https://google.com',
//   config_whatsapp: 'https://google.com',
//   config_facebook: null,
//   config_messenger: null,
//   config_viber: null,
//   config_twitter: 'https://google.com',
//   config_instagram: 'https://google.com',
//   config_youtube: 'https://google.com',
//   config_line: null,
// };

const SocialIcons = ({
  GridContainerProps = {},
  isFullRow = false,
  itemsPerRow = 5,
  ImageStyles = {},
  isHeader = false,
}) => {
  const { siteSettings, achievementCounter } = useSelector((x) => x.lookup);

  const navigate = useNavigate();

  const isSm = useResponsive('down', 'md');

  const {
    // config_phonenumber,
    config_telegram,
    config_wechat,
    config_whatsapp,
    config_facebook,
    config_messenger,
    config_viber,
    config_twitter,
    config_instagram,
    config_youtube,
    config_line,
  } = siteSettings || {};

  const socialCount = useMemo(() => {
    let count = isHeader ? 1 : 0; // achievement button so 1

    if (siteSettings?.config_telegram) count += 1;
    if (siteSettings?.config_wechat) count += 1;
    if (siteSettings?.config_whatsapp) count += 1;
    if (siteSettings?.config_facebook) count += 1;
    if (siteSettings?.config_messenger) count += 1;
    if (siteSettings?.config_viber) count += 1;
    if (siteSettings?.config_twitter) count += 1;
    if (siteSettings?.config_instagram) count += 1;
    if (siteSettings?.config_youtube) count += 1;
    if (siteSettings?.config_line) count += 1;

    return count;
  }, [siteSettings]);

  const openSocial = (link) => {
    window.open(
      link,
      '_blank'
      // 'noopener noreferrer'
    );
  };

  const headerItemSx = (order) => (isHeader ? { flexBasis: 'auto', maxWidth: 'none', order } : {});

  if (!socialCount) return <></>;

  return (
    <Grid container {...GridContainerProps}>
      {isHeader ? (
        <Grid
          item
          xs={isFullRow && socialCount > itemsPerRow ? 12 / socialCount : 12 / itemsPerRow}
          sx={{ display: 'flex', justifyContent: 'center', ...headerItemSx(5) }}
          onClick={() => {
            navigate('/#achievements');
            setTimeout(() => {
              const el = document.getElementById('achievements');
              if (el) {
                el.scrollIntoView({ behavior: 'smooth' });
              }
            }, 100); // adjust timing if needed
          }}
        >
          <Box component={m.div} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.8 }} sx={{ cursor: 'pointer' }}>
            <Badge
              badgeContent={achievementCounter || 0}
              color="error"
              anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
              sx={{
                '& .MuiBadge-badge': {
                  // top: 8,
                  left: 4,
                },
              }}
            >
              <Box
                component={'img'}
                sx={{ width: '100%', cursor: 'pointer', ...ImageStyles }}
                src={require('../../assets/home/achievement_gold.png')}
              />
            </Badge>
          </Box>
        </Grid>
      ) : (
        ''
      )}

      {isSm && (
        <Grid
          item
          xs={isFullRow && socialCount > itemsPerRow ? 12 / socialCount : 12 / itemsPerRow}
          sx={{ display: 'flex', justifyContent: 'center', ...headerItemSx(4) }}
          onClick={() => navigate('/angpau')}
        >
          <Box component={m.div} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.8 }}>
            <Image
              sx={{ width: '100%', cursor: 'pointer', ...ImageStyles }}
              src={`${S3_ASSETS_URL}home/angpau_button.png`}
            />
          </Box>
        </Grid>
      )}
      {config_viber && (
        <Grid
          item
          xs={isFullRow && socialCount > itemsPerRow ? 12 / socialCount : 12 / itemsPerRow}
          sx={{ display: 'flex', justifyContent: 'center', ...headerItemSx(3) }}
          onClick={() => openSocial(config_viber)}
        >
          <Box component={m.div} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.8 }}>
            <Image
              sx={{ width: '100%', cursor: 'pointer', ...ImageStyles }}
              src={`${S3_ASSETS_URL}home/social_icons/viber_gold.webp`}
            />
          </Box>
        </Grid>
      )}
      {/* {config_phonenumber && (
        <Grid item xl={12 / 5} lg={12 / 5} md={12 / 5} sm={12 / 5} xs={12/3}>
          <Box
            onClick={() => openSocial(config_phonenumber)}
            component={m.div}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.8 }}
          >
            <Image sx={{ width: '100%', cursor: 'pointer', ...ImageStyles }} src={`${S3_ASSETS_URL}home/social_icons/phone_gold.png`} />
          </Box>
        </Grid>
      )} */}
      {config_messenger && !isHeader ? (
        <Grid
          item
          xs={isFullRow && socialCount > itemsPerRow ? 12 / socialCount : 12 / itemsPerRow}
          sx={{ display: 'flex', justifyContent: 'center', ...headerItemSx(3) }}
          onClick={() => openSocial(config_messenger)}
        >
          <Box component={m.div} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.8 }}>
            <Image
              sx={{ width: '100%', cursor: 'pointer', ...ImageStyles }}
              src={`${S3_ASSETS_URL}home/social_icons/messenger_gold.webp`}
            />
          </Box>
        </Grid>
      ) : (
        ''
      )}

      {config_telegram && (
        <Grid
          item
          xs={isFullRow && socialCount > itemsPerRow ? 12 / socialCount : 12 / itemsPerRow}
          sx={{ display: 'flex', justifyContent: 'center', ...headerItemSx(1) }}
          onClick={() => openSocial(config_telegram)}
        >
          <Box component={m.div} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.8 }}>
            <Image
              sx={{ width: '100%', cursor: 'pointer', ...ImageStyles }}
              src={`${S3_ASSETS_URL}home/social_icons/telegram_gold.webp`}
            />
          </Box>
        </Grid>
      )}

      {config_facebook && !isHeader ? (
        <Grid
          item
          xs={isFullRow && socialCount > itemsPerRow ? 12 / socialCount : 12 / itemsPerRow}
          sx={{ display: 'flex', justifyContent: 'center', ...headerItemSx(3) }}
          onClick={() => openSocial(config_facebook)}
        >
          <Box component={m.div} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.8 }}>
            <Image
              sx={{ width: '100%', cursor: 'pointer', ...ImageStyles }}
              src={`${S3_ASSETS_URL}home/social_icons/fb_gold.webp`}
            />
          </Box>
        </Grid>
      ) : (
        ''
      )}
      {config_twitter && (
        <Grid
          item
          xs={isFullRow && socialCount > itemsPerRow ? 12 / socialCount : 12 / itemsPerRow}
          sx={{ display: 'flex', justifyContent: 'center', ...headerItemSx(3) }}
          onClick={() => openSocial(config_twitter)}
        >
          <Box component={m.div} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.8 }}>
            <Image
              sx={{ width: '100%', cursor: 'pointer', ...ImageStyles }}
              src={`${S3_ASSETS_URL}home/social_icons/twitter_gold.webp`}
            />
          </Box>
        </Grid>
      )}
      {config_instagram && (
        <Grid
          item
          xs={isFullRow && socialCount > itemsPerRow ? 12 / socialCount : 12 / itemsPerRow}
          sx={{ display: 'flex', justifyContent: 'center', ...headerItemSx(3) }}
          onClick={() => openSocial(config_instagram)}
        >
          <Box component={m.div} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.8 }}>
            <Image
              sx={{ width: '100%', cursor: 'pointer', ...ImageStyles }}
              src={`${S3_ASSETS_URL}home/social_icons/instagram_gold.webp`}
            />
          </Box>
        </Grid>
      )}
      {config_line && (
        <Grid
          item
          xs={isFullRow && socialCount > itemsPerRow ? 12 / socialCount : 12 / itemsPerRow}
          sx={{ display: 'flex', justifyContent: 'center', ...headerItemSx(3) }}
          onClick={() => openSocial(config_line)}
        >
          <Box component={m.div} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.8 }}>
            <Image
              sx={{ width: '100%', cursor: 'pointer', ...ImageStyles }}
              src={`${S3_ASSETS_URL}home/social_icons/line_gold.webp`}
            />
          </Box>
        </Grid>
      )}
      {config_wechat && (
        <Grid
          item
          xs={isFullRow && socialCount > itemsPerRow ? 12 / socialCount : 12 / itemsPerRow}
          sx={{ display: 'flex', justifyContent: 'center', ...headerItemSx(3) }}
          onClick={() => openSocial(config_wechat)}
        >
          <Box component={m.div} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.8 }}>
            <Image
              sx={{ width: '100%', cursor: 'pointer', ...ImageStyles }}
              src={`${S3_ASSETS_URL}home/social_icons/wechat_gold.webp`}
            />
          </Box>
        </Grid>
      )}
      {config_whatsapp && (
        <Grid
          item
          xs={isFullRow && socialCount > itemsPerRow ? 12 / socialCount : 12 / itemsPerRow}
          sx={{ display: 'flex', justifyContent: 'center', ...headerItemSx(2) }}
          onClick={() => openSocial(config_whatsapp)}
        >
          <Box component={m.div} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.8 }}>
            <Image
              sx={{ width: '100%', cursor: 'pointer', ...ImageStyles }}
              src={`${S3_ASSETS_URL}home/social_icons/whatsapp_gold.webp`}
            />
          </Box>
        </Grid>
      )}
      {config_youtube && (
        <Grid
          item
          xs={isFullRow && socialCount > itemsPerRow ? 12 / socialCount : 12 / itemsPerRow}
          sx={{ display: 'flex', justifyContent: 'center', ...headerItemSx(3) }}
          onClick={() => openSocial(config_youtube)}
        >
          <Box component={m.div} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.8 }}>
            <Image
              sx={{ width: '100%', cursor: 'pointer', ...ImageStyles }}
              src={`${S3_ASSETS_URL}home/social_icons/youtube_gold.webp`}
            />
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

SocialIcons.propTypes = {
  GridContainerProps: PropTypes.object,
  ImageStyles: PropTypes.object,
  isFullRow: PropTypes.bool,
  itemsPerRow: PropTypes.number,
};

export default SocialIcons;
